import React, {useState, useEffect} from "react";
import { Link, useNavigate } from 'react-router-dom'
import { dashboardApproveUrl } from "../../apis/urls";
import axios from "axios";
import { $ } from "react-jquery-plugin";
import { decode } from "html-entities"; 

const DashBoard = () => {


    useEffect( ()=> {
        $('body').removeClass('sidebar-collapsed sidebar-active').addClass('');
        ApproveListing();
    },[])

    let navigate = useNavigate()


    let role = localStorage.getItem('userrole');

    // console.log("role", role)




    const [result, setResult] = useState([]);   

    let token = "Bearer "+localStorage.getItem('token');

    const ApproveListing = () => {
         
        const instance = axios.create({

            baseURL: dashboardApproveUrl,

            timeout: 1000000,

            headers: {'authorization': token}

          });
          
          instance.get('').then((response) =>{
            
            setResult(response.data.data);

            console.log(response.data.data)
          }).catch((error) =>{
            
            localStorage.removeItem('token')
    
            navigate("/")

            console.log('error',error.message)
            
          });

    }


    let sl=1;

    return( 
        <div>
            <aside class="right-side areas">
                <div class="content-area dash-contentss">
                <div class="jumbotron jumbotron-fluid jumbotran-rules">

                    <div class="page-title-wrpr">
                        <div class="page-title-left-column">
                            <h2 class="page-title"> Dashboard - Pending by GIAA  </h2>
                        </div>
                    </div>

                        <div class="container">


                            <table class="table table-rules">
                                <thead>
                                    <tr className="rules-table-head">
                                    <th scope="col">Sl.No</th>
                                    <th scope="col">School Name</th>
                                    <th scope="col">Pending by GIAA</th>
                                    <th scope="col" style={{textAlign:'center'}}>Actions</th>
                                    </tr>
                                </thead>
                                <tbody className="rules-table-content">
                                {
                                        
                                    result?.map((item,index) =>(

                                        <tr>
                                            <td>{sl++}</td>
                                            <td>{decode(item.schoolName)}</td>
                                            <td>{item.count}</td>
                                            <td>
                                                <div className="list-action-wrpr showicons roundicons-text">
                                                    <div className="list-action-wrpr">
                                                    <Link  to={"/school_list/athlet_list/"+item.id} data-toggle="tooltip" title="View">
                                                        <i class="view icon-eye"></i>
                                                        <span>View</span>
                                                    </Link>
                                                    </div>
                                                </div>
                                            </td>
                                        
                                        </tr>
                                    ))
                                }
                                
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </aside>
        </div>
    )
};

export default DashBoard;
